import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ palette, spacing }) => ({
  category: {
    marginRight: spacing(13),
  },
  chip: {
    background: palette.green.light,
    color: 'white',
    borderColor: palette.green.light,
    fontSize: spacing(12),
    lineHeight: spacing(16),
  },
  newChip: {
    backgroundColor: palette.yellow.main,
    color: '#000',
    marginLeft: '8px',
    borderColor: palette.yellow.main,
    fontSize: spacing(8),
    lineHeight: spacing(12),
    height: '15px',
  },
  incomplete: {
    background: palette.yellow.main,
    color: palette.gray[100],
    borderColor: palette.yellow.main,
  },
  mainTable: {
    width: '100%',
    height: '650px',
  },
  iconWhatsApp: {
    width: spacing(24),
    color: palette.green.light,
  },
  tooltip: {
    '& .MuiTooltip-tooltip': {
      backgroundColor: palette.primary.main,
      color: palette.gray[4],
    },
    '& .MuiTooltip-arrow': {
      color: palette.primary.main,
    },
  },
  tooltipBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  supportIcon: {
    marginRight: spacing(8),
  },
  link: {
    color: palette.primary.main,
    fontSize: spacing(14),
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  tooltipTrigger: {
    display: 'flex',
    alignItems: 'center',
    color: palette.primary.main,
    fontSize: spacing(7),
  },
}))
